import { render } from "./MessageSender.vue?vue&type=template&id=4a7308d2"
import script from "./MessageSender.vue?vue&type=script&lang=js"
export * from "./MessageSender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__